import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import { GenericModule } from "@/components/GenericModule";
import { findNav } from "@/nav";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import RABillTracker from "@/pages/RABillTracker";
import GRNInspection from "@/pages/GRNInspection";
import RFQTracker from "@/pages/RFQTracker";
import InvoiceQueue from "@/pages/InvoiceQueue";
import ContractAward from "@/pages/ContractAward";
import UsersPage from "@/pages/Users";
import DeptDashboard from "@/pages/DeptDashboard";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-sm text-slate-500">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <Navigate to="/" replace />;
};

const ModuleRoute = () => {
  const { dept, slug } = useParams();
  const { dept: d, item } = findNav(dept, slug);
  if (!item?.module) return <Navigate to="/" replace />;
  return <GenericModule key={item.module} moduleKey={item.module} deptName={d.name} />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><AppLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="/qs/ra-bills" element={<RABillTracker />} />
              <Route path="/stores/grn" element={<GRNInspection />} />
              <Route path="/purchase/rfq" element={<RFQTracker />} />
              <Route path="/finance/invoices" element={<InvoiceQueue />} />
              <Route path="/contracts/award" element={<ContractAward />} />
              <Route path="/users" element={<AdminOnly><UsersPage /></AdminOnly>} />
              <Route path="/:dept/dashboard" element={<DeptDashboard />} />
              <Route path="/:dept/:slug" element={<ModuleRoute />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
